module.exports = __webpack_public_path__ + "img/mindSet.24a606a0.png";